document.addEventListener('DOMContentLoaded', function () {

    if (document.querySelector('.anaphylaxis-treatment-slider')) {
        const swiper = new Swiper('.anaphylaxis-treatment-slider', {
            direction: "horizontal",
            slidesPerView: 1,
            spaceBetween: 10,
            loop: false,
            observer: true,
            observeParents: true,
            pagination: {
                el: '.anaphylaxis-treatment-slider .swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.anaphylaxis-treatment-slider .swiper-button-next',
                prevEl: '.anaphylaxis-treatment-slider .swiper-button-prev',
            },
            on: {
                slideChangeTransitionEnd: function () {
                    dataLayer.push({
                        event: 'web_dad_slider',
                        slidernumber: '1',
                        slide: this.slides[this.activeIndex].dataset.slide,
                        property:'caregiver'
                    });
                }
            }
        });
    }

    document.querySelector('.custom-swiper-button-next')?.addEventListener('click', function () {
        document.querySelector('.anaphylaxis-treatment-slider .swiper-button-next')?.click();
    });

    document.querySelector('.custom-swiper-button-prev')?.addEventListener('click', function () {
        document.querySelector('.anaphylaxis-treatment-slider .swiper-button-prev')?.click();
    });

    if (document.querySelector('.anaphylaxis-safety-slider')) {
        const swiper = new Swiper('.anaphylaxis-safety-slider', {
            direction: "horizontal",
            slidesPerView: "auto",
            spaceBetween: 24,
            loop: true,
            observer: true,
            observeParents: true,
            centeredSlides: true,
            pagination: {
                el: '.anaphylaxis-safety-slider .swiper-pagination',
                clickable: true,
            },
        });
    }

    // ===== Anaphylaxis LP DataLayer Events =====

    document.querySelectorAll('.caregiver-cta-btn').forEach((caregiverCta) => {
        caregiverCta.addEventListener('click', function () {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'dad_cta_click',
                place: this.dataset.position,
                property:'caregiver'
            });
        });
    });

    if (document.body.classList.contains('anaphylaxis-lp') || document.body.classList.contains('anaphylaxis-lp-en')) {
        let isFirstClickHandled = false;

        const buttons = document.querySelectorAll('.anaphylaxis-download-checklist-btn');

        buttons.forEach((btn) => {
            btn.addEventListener('click', function (e) {
                const position = this.dataset.position;
                if (!position) return;

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: `checklist_download_position_${position}`,
                    property:'caregiver'
                });

                const cookie = Utility.getCookie('_gcl_au');
                const cookieAccepted = cookie && cookie !== '_gcl_au';

                if (cookieAccepted && !isFirstClickHandled) {
                    console.log('First click when cookie accepted');
                    isFirstClickHandled = true;
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    return false;
                }
            }, true);
        });

        const posterButtons = document.querySelectorAll('.anaphylaxis-poster-btn');

        posterButtons.forEach(function (btn) {
            btn.addEventListener('click', function () {
                const position = this.getAttribute('data-position');

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'anxs_poster_download',
                    place: position,
                    property:'caregiver'
                });
            });
        });
    }
});